import * as mutationTypes from './mutation-types'

import { filterItems, prepareData } from './helpers'

const Accounts = {
  state() {
    return {
      data: [],
    }
  },

  getters: {
    processedAccounts: ({ data }, _getters, { query }) => {
      return filterItems(data, query.currentQuery)
    },
  },

  mutations: {
    [mutationTypes.SET_ACCOUNTS_DATA](state, data) {
      state.data = prepareData(data, 'Account')
    },
  },
}

export default Accounts
